import {
  Grid,
  Card,
  CardContent,
  Tooltip,
  IconButton,
  Typography,
  Stack,
  Button,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import ResponsiveDataGrid from "../../../../../components/MobileList/ResponsiveDataGrid";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Reports } from "../../../../../app/slices/reportsSlice";
import { setCityTable } from "../../../../../app/slices/provincesSlice";
import dayjs from "dayjs";
import { MdOutlineClear } from "react-icons/md";
import { BsFillFileEarmarkExcelFill } from "react-icons/bs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const LazyPosTable = (isFetchData) => {
  const _LazyPos = useSelector((state) => state.reports.lazyPos);
  const loading = useSelector((state) => state.reports.reports.loading);
  const _provinces = useSelector((state) => state.provinces.provinces.data);
  // const _Cities = useSelector((state) => state.provinces.cities.data);
  // const jRepListData = useSelector((state) => state.user.jRepList.data);

  const dispatch = useDispatch();

  const [search, setSearch] = useState({
    start_date: dayjs().format("YYYY-MM-01"),
    // j_rep_id: null,
    // search: "",
    // province_id: null,
    // city_id: [],
  });

  const [provinceId, setProvinceId] = useState(null);

  const columns = [
    {
      field: "id",
      headerName: "#",
      flex: 0.2,
      sortable: false,
      valueGetter: (params) =>
        (params.api?.getRowIndexRelativeToVisibleRows?.(params.id) ?? 0) + 1,
    },
    {
      field: "pos_name",
      headerName: "اسم النقطة",
      flex: 1,
      renderCell: (params) => (
        <Stack>
          <Typography>{params.row.pos_name}</Typography>
          <Typography variant="caption">{params.row.mobile}</Typography>
        </Stack>
      ),
    },
    {
      field: "pos_number",
      headerName: "رقم النقطة",
      flex: 1,
    },
    {
      field: "owner",
      headerName: "اسم المالك",
      flex: 1,
    },
    {
      field: "mobile",
      headerName: "رقم الهاتف",
      flex: 1,
    },
    // {
    //   field: "j_rep_name",
    //   headerName: "اسم المندوب",
    //   flex: 1,
    // },
    {
      field: "last_transaction_date",
      headerName: "آخر تعامل",
      flex: 1,
      renderCell: (params) => (
        <Typography>
          {params.row.last_transaction_date
            ? dayjs(params.row.last_transaction_date).format("YYYY-MM-DD")
            : "لا يوجد"}
        </Typography>
      ),
    },
    {
      field: "days_inactive",
      headerName: "أيام عدم النشاط",
      flex: 1,
      renderCell: (params) => {
        const daysInactive = params.row.last_transaction_date
          ? dayjs().diff(dayjs(params.row.last_transaction_date), "day")
          : null;
        return (
          <Typography color={daysInactive > 30 ? "error" : "inherit"}>
            {daysInactive !== null ? `${daysInactive} يوم` : "غير نشط"}
          </Typography>
        );
      },
    },
    // {
    //   field: "total_balance",
    //   headerName: "الرصيد الحالي (IQD)",
    //   flex: 1,
    //   renderCell: (params) => (
    //     <Typography>
    //       {parseFloat(params.row.total_balance || 0)?.toLocaleString()}
    //     </Typography>
    //   ),
    // },
    // {
    //   field: "province_name",
    //   headerName: "المحافظة",
    //   flex: 1,
    // },
    // {
    //   field: "city_name",
    //   headerName: "المدينة",
    //   flex: 1,
    // },
  ];

  const handleSearch = () => {
    dispatch(
      Reports.getLazyPos({
        start_date: search.start_date,
        j_rep_id: search.j_rep_id,
        search: search.search,
        province_id: search.province_id,
        city_id: search.city_id,
      })
    );
  };

  // Remove automatic data fetching on page load
  // Data will only be fetched when user clicks the search button
  // useEffect(() => {
  //   if (isFetchData) {
  //     dispatch(
  //       Reports.getLazyPos({
  //         start_date: search.start_date,
  //         // j_rep_id: search.j_rep_id,
  //         // search: search.search,
  //         // province_id: search.province_id,
  //         // city_id: search.city_id,
  //       })
  //     );
  //   }
  // }, [dispatch, isFetchData, search]);

  // Handle province change to update cities
  useEffect(() => {
    const selectedCities = _provinces?.filter((x) =>
      x.id === provinceId ? x.city : null
    )[0];
    if (selectedCities) {
      dispatch(setCityTable(selectedCities?.city ?? []));
    }
    // Reset city selection when province changes
    setSearch((prev) => ({
      ...prev,
      city_id: [],
    }));
  }, [provinceId, _provinces, dispatch]);

  return (
    <Card>
      <CardContent>
        <Grid container rowSpacing={1} columnSpacing={2}>
          {/* <Grid item xs={12} md={2}>
            <TextField
              size="small"
              value={search.search}
              onChange={(e) => {
                setSearch({
                  ...search,
                  search: e.target.value,
                });
              }}
              label="بحث عن اسم النقطة او رقمها"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectJRep
              onChange={(event, value) => {
                setSearch({
                  ...search,
                  j_rep_id: value ? value.id : null,
                });
              }}
              value={
                jRepListData?.filter((x) => x.id === search.j_rep_id)[0] ?? null
              }
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectProvince
              onChange={(e, newValue) => {
                setProvinceId(newValue ? newValue.id : null);
                setSearch({
                  ...search,
                  province_id: newValue ? newValue.id : null,
                });
              }}
              value={_provinces?.filter((x) => x.id === provinceId)[0] ?? null}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectCity
              multiple
              onChange={(e, newValue) => {
                setSearch({
                  ...search,
                  city_id: newValue ? newValue.map((city) => city.id) : [],
                });
              }}
              value={
                _Cities?.filter((x) => search.city_id.includes(x.id)) ?? []
              }
            />
          </Grid> */}
          <Grid item xs={12} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="تاريخ البداية *"
                value={dayjs(search.start_date)}
                onChange={(newValue) => {
                  setSearch({
                    ...search,
                    start_date: newValue
                      ? dayjs(newValue).format("YYYY-MM-DD")
                      : "",
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    fullWidth
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      placeholder: "يوم/شهر/سنة",
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={2}>
            <Stack direction="row" spacing={1}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSearch}
                disabled={loading || !search.start_date}
              >
                بحث
              </Button>
              <Tooltip title="تصدير ملف اكسل">
                <IconButton
                  onClick={() => {
                    dispatch(Reports.exportLazyPos(search));
                  }}
                  disabled={!search.start_date}
                >
                  <BsFillFileEarmarkExcelFill />
                </IconButton>
              </Tooltip>
              <Tooltip title="الغاء الفلتر">
                <IconButton
                  onClick={() => {
                    const cleared = {
                      start_date: dayjs().format("YYYY-MM-01"),
                      // j_rep_id: null,
                      // search: "",
                      // province_id: null,
                      // city_id: [],
                    };
                    setSearch(cleared);
                    setProvinceId(null);
                    dispatch(Reports.getLazyPos(cleared));
                  }}
                >
                  <MdOutlineClear />
                </IconButton>
              </Tooltip>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <ResponsiveDataGrid gridHeight={null}
              rows={
                _LazyPos.data?.map((x, index) => ({
                  ...x,
                  id: x.user_id || x.pos_id || index + 1,
                })) ?? []
              }
              autoHeight
              columns={columns}
              rowCount={_LazyPos.total}
              loading={loading}
              rowHeight={60}
              selectionModel={[]}
              rowsPerPageOptions={[100]}
              paginationMode="server"
              disableSelectionOnClick
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default LazyPosTable;
